const main = async () => {
    // async load axios module
    const { default: axios } = await import(/* webpackChunkName: "axios" */ 'axios');

    const fetchVimeoAlbum = async (limit) => {
        try {
            const response = await axios.get('/actions/vimeo-api-module/proxy/get-vimeo-album', {
                params: {}
            });
            // return response from vimeo api module
            return response.data.data.slice(0,limit);
        } catch (errors) {
            console.error(errors);
        }
    }

    const createVideoElement = item => {
        let title = item.name;
        let videoDate = new Date(item.created_time);
        let convertedDate = videoDate.toLocaleString('default', { month: 'long', day: '2-digit', year: 'numeric' });
        let description = item.description;
        let videoId = item.uri.split('/videos/')[1];
        let videoUrl = 'https://player.vimeo.com/video/' + videoId;
        let url = item.link;

        const videoWrapper = document.createElement('div');
        videoWrapper.classList.add('col', 'd-flex', 'my-3');

        videoWrapper.innerHTML = `
            <div class='card w-100'>
              <div class='card-header'>
                <div class='small mb-1'>${convertedDate}</div>
                <h3 class='h5 mb-0'>${title}</h3>
              </div>
              <div class='video-embed-container'><iframe src='${videoUrl}' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
              <div class='card-body'>
                <p class='mb-0'>${description}</p>
              </div>
            </div>
        `;
        // return video element
        return videoWrapper;
    }

    const createVideoList = videoItems => {
        const videoList = document.querySelector('.ag-minute-videos .placeholder');

        if (Array.isArray(videoItems) && videoItems.length > 0) {
            videoItems.map(videoItem => {
                videoList.appendChild(createVideoElement(videoItem));
            });
        } else if (videoItems) {
            videoList.appendChild(createVideoElement(videoItems));
        }
    }
    // return array of videos
    let limit = null;
    if (window.limit) {
        limit = window.limit;
    }
    return createVideoList(await fetchVimeoAlbum(limit));
};

main().then(() => {
    let placeholderCards = document.querySelectorAll('.ag-minute-videos .placeholder-card-wrap');
    placeholderCards.forEach(el => {
        el.remove();
    });
});